import { action, makeObservable, observable } from 'mobx';

export class AdminLayoutManager {
  static instance: AdminLayoutManager | undefined;

  @observable
  navigationFolded: boolean = false;

  @observable
  selectedPages: Set<string> = new Set();

  static get shared() {
    if (AdminLayoutManager.instance === undefined) {
      AdminLayoutManager.instance = new AdminLayoutManager();
    }

    return AdminLayoutManager.instance;
  }

  constructor() {
    makeObservable(this);
  }

  @action
  setNavigationFolded(value: boolean) {
    this.navigationFolded = value;
  }
}
